import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { COMMUNITY_ENDPOINTS } from 'src/app/core/api/endpoints/community';

@Injectable({
  providedIn: 'root'
})
export class CommunityService {
  private api = inject(ApiService);

  getCommunities(params: any): Observable<any> {
    return this.api.get(
      COMMUNITY_ENDPOINTS.V2.COMMUNITIES,
      { params: params }
    );
  }

  addCommunity(data: any): Observable<any> {
    return this.api.post(
      COMMUNITY_ENDPOINTS.V2.COMMUNITIES,
      data
    );
  }

  editCommunity(id: number, data: any): Observable<any> {
    return this.api.put(
      COMMUNITY_ENDPOINTS.V2.COMMUNITY(id),
      data
    );
  }

  getCommunity(id: number): Observable<any> {
    return this.api.get(
      COMMUNITY_ENDPOINTS.V2.COMMUNITY(id)
    );
  }
}
